import { BaseWrapper, H4, H5 } from '@base'
import { Devices, Spacings, Text } from '@styles'
import styled from 'styled-components'

export const InputWrapper = styled.div``

// will be used for entire section i.e., page ()
export const SectionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_3B};
`

// defined grids
export const GridWrapper = styled.div`
	display: grid;
	grid-template-columns: ${({ itemPerRow }) => `repeat(${itemPerRow?.[0] ?? 2}, 1fr)`};
	grid-gap: ${({ doubleGap }) => (doubleGap ? Spacings.SPACING_4B : Spacings.SPACING_2B)};

	@media (${Devices.tablet}) {
		grid-template-columns: ${({ itemPerRow }) => `repeat(${itemPerRow?.[1] ?? 2}, 1fr)`};
	}

	@media (${Devices.desktop}) {
		grid-template-columns: ${({ itemPerRow }) => `repeat(${itemPerRow?.[2] ?? 2}, 1fr)`};
	}
`

// a white color wrapper with padding
export const SubSectionWrapper = styled(BaseWrapper)`
	// height: 100%;
	display: flex;
	flex-direction: column;
	min-height: fit-content;
	padding: ${Spacings.SPACING_5B} ${Spacings.SPACING_4B};
	gap: ${Spacings.SPACING_2B};
`

// centre H4 heading
export const SectionHeader = styled(H4)`
	border-bottom: ${({ theme }) => `1px solid ${theme.palette.background.searchgrey}`};
	padding: ${Spacings.SPACING_2B};
	background-color: ${({ theme }) => `${theme.palette.background.searchgrey}`};
	border-radius: ${Spacings.SPACING_1B};
	/* Gap between the section label and the table under it. */
	margin-bottom: ${Spacings.SPACING_2B};
`

// left aligned heading
export const SubsectionHeading = styled(H5)``

export const SectionTableWrapper = styled.div`
	position: relative;
	& > nth-child(2): {
		height: 100%;
	}
`

export const TableWrapper = styled.section`
	display: flex;
	flex-direction: column;
	flex: 1;
`

export const DescriptionWrapper = styled.div`
	padding: ${Spacings.SPACING_3B} 0;
	& > div {
		line-height: ${Text.LINE_HEIGHT_MAX};
		margin-top: ${Spacings.SPACING_2};
		font-weight: ${Text.BOLD_600};
		color: ${({ theme }) => theme.palette.text.black};
	}
`

export const DescriptionHeading = styled(H4)`
	color: ${({ theme }) => theme.palette.text.label};
	line-height: ${Text.LINE_HEIGHT_MAX};
	margin: ${Spacings.SPACING_1B} 0;
	padding: ${Spacings.SPACING_2B} 0;

	border-bottom: ${({ theme, noBorder }) => (noBorder ? 'none' : `1px solid ${theme.palette.background.searchgrey}`)};
`

export const DrawerNavigationWrapper = styled.div`
	padding: 0 ${Spacings.SPACING_4B} ${Spacings.SPACING_4B};
	max-width: 100%;
	position: sticky;
	top: 0;
	z-index: 498;
	background: ${({ theme }) => theme.palette.background.main};

	@media ${Devices.tablet} {
		padding: ${Spacings.SPACING_2B};
	}
	& > div {
		display: flex;
		justify-content: center;
	}
`

export const CommentsSection = styled.div`
	height: -webkit-fill-available;
	overflow: scroll;
	/* Hide scrollbar for Chrome, Safari and Opera */
	&::-webkit-scrollbar {
		display: none;
	}
	/* Hide scrollbar for IE, Edge and Firefox */
	& {
		-ms-overflow-style: none; /* IE and Edge */
		scrollbar-width: none; /* Firefox */
	}
`

export const BiInputFieldWrapper = styled.div`
	display: flex;
	flex-direction: row;
	& > div {
		width: 100%;
	}
	column-gap: ${Spacings.SPACING_4B};
`

export const SectionBreakLine = styled.div`
	margin: ${Spacings.SPACING_2B} 0;
	border-bottom: ${({ theme }) => `1px solid ${theme.palette.background.searchgrey}`};
`

export const StickyFooter = styled.div`
	bottom: 0;
	z-index: 1;
	background: ${({ theme }) => theme.palette.background.searchgrey};
	border-top: 1px solid ${({ theme }) => theme.palette.background.searchgrey};
	position: sticky;
	margin-left: ${Spacings.SPACING_1};

	padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
	background: ${({ theme }) => theme.palette.background.white};
	box-shadow: 0 ${Spacings.SPACING_1B} ${Spacings.SPACING_5B} 0 rgb(0 0 0 / 5%);
`

export const InspectionFooterWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: end;
	gap: ${Spacings.SPACING_2B};
`

export const ImageSectionWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`
export const ButtonsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap: ${Spacings.SPACING_2B};
`

export const DrawerButtonsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	justify-content: ${({ onRight }) => (onRight ? 'end' : 'space-between')};
	gap:${({ onRight }) => onRight && Spacings.SPACING_2B}};
`

export const OtherDocumentsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: ${Spacings.SPACING_2B};
`

export const NoteWrapper = styled.div`
	margin: ${Spacings.SPACING_2B};
	padding: ${Spacings.SPACING_2B};
	border-radius: ${Spacings.SPACING_2B};
	border: 1px solid ${({ theme }) => theme.palette.background.red};
	background-color: ${({ theme }) => theme.palette.background.redLightest};
	color: ${({ theme }) => theme.palette.background.red};
`

export const RadioButtonWrapper = styled.div`
	display: flex;
	gap: ${Spacings.SPACING_1B};
`

export const ItemWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	margin-top: ${Spacings.SPACING_2B};
`

export const RadioButtonsWrapper = styled.div`
	display: flex;
	justify-content: end;
	gap: ${Spacings.SPACING_8B};
`

export const VotingOptionsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_2B};
	margin-bottom: ${Spacings.SPACING_4B};
`

export const VotingOptionWrapper = styled.div`
	display: flex;
	flex-direciton: row;
	justify-content: space-between;
	gap: ${Spacings.SPACING_2B};
`

export const VotedOptionWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	position: relative;
	overflow: hidden;
	padding: ${Spacings.SPACING_1B} ${Spacings.SPACING_2B};
	border-radius: 8px;
	cursor: pointer;
	align-items: center;
	justify-content: space-between;
	align-items: center;
	transition: background 0.2s;
	border: 1px solid #e9edef;
`

export const ProgressFill = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	background-color: ${({ theme }) => theme.palette.background.pastelBlue};
	width: ${({ Percentage }) => Percentage}%;
	transition: width 0.5s ease-out;
	z-index: 0;
`

export const VotingContent = styled.div`
	position: relative;
	z-index: 1;
	color: #3b4a54;
`

export const VoteCount = styled.div`
	position: relative;
	z-index: 1;
`

export const VoterHeader = styled.div`
	display: flex;
	flex-direction: row;
	margin: ${Spacings.SPACING_1B};
`

export const OptionHeading = styled.span`
	font-size: ${Text.SMALL};
	color: ${({ theme }) => theme.palette.text.greyTwo};
`

export const VotersListWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_2B};
`
